module.exports = __webpack_public_path__ + "img/camera.5ba135de.png";